import { Navigate, useLocation } from "react-router-dom";
import { useAuth, roleHome } from "../lib/auth";
import { Spinner } from "./Brand";

export default function ProtectedRoute({ children, roles }) {
    const { user } = useAuth();
    const loc = useLocation();
    if (user === undefined) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#FAFAF8]">
                <Spinner />
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
    }
    if (user.must_change_password && loc.pathname !== "/change-password") {
        return <Navigate to="/change-password" replace />;
    }
    if (roles && !roles.includes(user.role)) {
        return <Navigate to={roleHome(user.role)} replace />;
    }
    return children;
}
